import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  TextField,
  Button,
  Rating,
  Stack,
  Chip,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import { ShoppingCart, LocationOn, Close, Delete } from "@mui/icons-material";
import { updateRating } from "../../services/source";
import { useAuth } from "../../context/AuthContext";

const AppCard = ({
  id,
  product_code,
  image,
  height = 500,
  alt = "product",
  title,
  subtitle,
  location = "Luanda",
  stock = 0,
  cartQuantity = 0,
  price,
  rating = 0,
  onAddCart,
  onDeleteProduct,
}) => {
  const [quantity, setQuantity] = useState(1);
  const [userRating, setUserRating] = useState(rating);
  const [openImage, setOpenImage] = useState(false);
  const remainingStock = stock - cartQuantity;
  const { customer } = useAuth();
  const isAdmin = customer?.role === "admin";

  const handleAddCart = () => {
    if (quantity < 1) {
      alert("Quantity must be at least 1");
      return;
    }

    if (quantity > remainingStock) {
      alert(`Only ${remainingStock} item(s) available.`);
      return;
    }

    onAddCart({
      product_code,
      image,
      title,
      quantity,
      price,
      stock,
      location,
    });
  };

  const handleDeleteCart = () => {
    if (!onDeleteProduct) return;

    const confirmDelete = window.confirm(`Delete product "${title}"?`);

    if (confirmDelete) {
      onDeleteProduct(id);
    }
  };

  return (
    <Card
      sx={{
        width: {
          xs: "100%",
          sm: 320,
        },
        maxWidth: 320,
        mx: "auto",
        borderRadius: 3,
        boxShadow: 3,
      }}
    >
      {/* PRODUCT IMAGE */}

      <CardMedia
        component="img"
        image={image}
        alt={alt}
        sx={{
          width: "100%",
          height: {
            xs: 200,
            sm: height,
          },
          objectFit: "cover",
          cursor: "pointer",
        }}
        onClick={() => setOpenImage(true)}
      />

      <CardContent>
        {/* LOCATION + STOCK */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 2,
          }}
        >
          {/* LOCATION */}

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <LocationOn fontSize="small" color="error" />

            <Typography
              variant="body2"
              sx={{
                ml: 0.5,
              }}
            >
              {location}
            </Typography>
          </Box>

          {/* STOCK */}

          <Chip
            label={`Stock: ${stock}`}
            color={stock > 0 ? "success" : "error"}
            size="small"
          />
        </Box>

        {/* PRICE */}

        {price && (
          <Typography
            variant="h6"
            sx={{
              mt: 2,
              fontWeight: "bold",
            }}
          >
            {Number(price).toLocaleString()}{" "}
            {location?.toLowerCase() === "lisboa" ? "€" : "Kz"}
          </Typography>
        )}

        {/* RATING */}

        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{
            mt: 2,
          }}
        >
          <Rating
            value={userRating}
            precision={0.5}
            onChange={async (event, newValue) => {
              if (!newValue) return;

              setUserRating(newValue);

              try {
                await updateRating({
                  product_code,

                  rating: newValue,
                });
              } catch (error) {
                console.log(error);
              }
            }}
          />
        </Stack>

        {/* QUANTITY */}

        <TextField
          fullWidth
          type="number"
          label="Quantity"
          value={quantity}
          onChange={(e) => setQuantity(Number(e.target.value))}
          inputProps={{
            min: 1,
            max: remainingStock,
          }}
          sx={{
            mt: 2,
          }}
        />

        {/* ADD CART BUTTON */}
        <Button
          fullWidth
          variant="contained"
          startIcon={<ShoppingCart />}
          disabled={remainingStock <= 0}
          onClick={handleAddCart}
          sx={{ mt: 2 }}
        >
          {remainingStock <= 0 ? "Sem Stock" : "Adicionar"}
        </Button>

        {/* DELETE CART BUTTON */}
        {isAdmin && (
          <Button
            color="error"
            fullWidth
            variant="contained"
            startIcon={<Delete />}
            sx={{
              mt: 2,
            }}
            onClick={handleDeleteCart}
          >
            Apagar
          </Button>
        )}
      </CardContent>

      {/* IMAGE PREVIEW DIALOG */}

      <Dialog
        open={openImage}
        onClose={() => setOpenImage(false)}
        maxWidth="lg"
      >
        <DialogContent
          sx={{
            position: "relative",
            p: 0,
            backgroundColor: "black",
          }}
        >
          <IconButton
            onClick={() => setOpenImage(false)}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              zIndex: 2,
              backgroundColor: "white",
            }}
          >
            <Close />
          </IconButton>

          <Box
            component="img"
            src={image}
            alt={alt}
            sx={{
              display: "block",
              maxWidth: {
                xs: "100vw",
                sm: "90vw",
              },
              maxHeight: {
                xs: "80vh",
                sm: "85vh",
              },
              objectFit: "contain",
            }}
          />
        </DialogContent>
      </Dialog>
    </Card>
  );
};

export default AppCard;
